import React, { useState } from 'react';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormFileUpload from '../../../../antd/form/FormFileUpload/FormFileUpload.jsx';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';
import { required, url } from '../../../../antd/form/FormValidation.js';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';

const SliderForm = ({ form, initialValues, onFinish }) => {
  const { t } = useTranslation();
  const [image, setImage] = useState(
    initialValues?.image || form.getFieldValue('image_object'),
  );

  return (
    <>
      <CollapseBlock collapse={true}>
        <Form onFinish={onFinish} initialValues={initialValues}>
          <FormFileUpload
            label={t('Obrázok')}
            name={'image_object'}
            accept="image/jpeg, image/png"
            rules={[required(t)]}
            onChange={(image) => {
              if (image === null) {
                setImage(null);
                return;
              }

              const reader = new FileReader();
              reader.onload = () => {
                const dataURL = reader.result;
                setImage(dataURL);
              };
              reader.readAsDataURL(image);
            }}
          />

          {image && <img style={{ marginBottom: '20px' }} src={image} alt="" />}

          <FormTextField
            label={t('URL')}
            name={'target_url'}
            rules={[required(t), url(t)]}
          />

          <FormTextField
            label={t('Popis')}
            name={'meta_name'}
            rules={[required(t)]}
          />

          <FormSwitch label={t('Zobraziť')} name={'active'} />

          <FormButtonsContainer>
            <FormButton submitKey={'sliders'} submitOnClick={true}>
              {t('Uložiť')}
            </FormButton>
          </FormButtonsContainer>
        </Form>
      </CollapseBlock>
    </>
  );
};

export default SliderForm;
